import { toast } from "react-toastify";

export const NotificationToaster = ({ message, type }) => { toast[type](message); }